import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
import { humanizeTag } from './format';

interface RealTalkViewProps {
  sentence: string | null;
  tags: string[] | null;
  /** @deprecated contact now lives in the PassportViewer header. */
  isContactable?: boolean;
  /** @deprecated contact now lives in the PassportViewer header. */
  onContact?: () => void;
  className?: string;
}

const RealTalkView: React.FC<RealTalkViewProps> = ({
  sentence,
  tags,
  className = '',
}) => {
  const hasContent = !!sentence || (tags && tags.length > 0);

  if (!hasContent) {
    return (
      <div className={`flex items-center justify-center py-16 text-slate-400 ${className}`}>
        <div className="text-center">
          <div className="text-2xl mb-1.5">💬</div>
          <p className="text-xs">No real talk yet</p>
        </div>
      </div>
    );
  }

  return (
    <div className={`max-w-2xl mx-auto px-4 py-5 sm:py-8 ${className}`}>
      <motion.div
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.35 }}
        className="relative bg-white rounded-2xl border border-slate-200 shadow-[0_2px_12px_rgba(0,0,0,0.04)] p-4 sm:p-8 overflow-hidden"
      >
        {/* Soft gradient accent */}
        <div
          className="absolute -top-16 -right-16 w-48 h-48 rounded-full opacity-20 blur-2xl pointer-events-none"
          style={{ background: 'radial-gradient(circle, #f9a8d4 0%, #db2777 70%)' }}
        />

        <Quote className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-pink-300 mb-2" />

        {sentence && (
          <p className="text-[13px] sm:text-base font-semibold text-slate-800 leading-snug">
            {sentence}
          </p>
        )}

        {tags && tags.length > 0 && (
          <div className="flex flex-wrap gap-1.5 mt-3 sm:mt-4">
            {tags.map((tag, i) => (
              <span
                key={`${i}-${tag}`}
                className="text-[11px] sm:text-xs font-medium px-2.5 py-1 rounded-full bg-pink-50 text-pink-600 border border-pink-100"
              >
                {humanizeTag(tag)}
              </span>
            ))}
          </div>
        )}
      </motion.div>
    </div>
  );
};

export default RealTalkView;
